import { SignIn } from "@clerk/remix";
import { Center } from "@mantine/core";

export default function SignInPage() {
  return (
    <Center>
      <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" />
    </Center>
  );
}
